import { ModuleWithProviders } from '@angular/core/src/metadata/ng_module';
import { Routes, RouterModule } from '@angular/router';
import { ReportsComponent } from './reports/reports.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { AdminComponent } from './admin/admin.component';
import { AuthGuard } from './common/auth.guard';
import { GuestComponent } from 'app/guest/guest.component';


export const ROUTES: Routes = [
    { path: 'login/auth', component: LoginComponent },
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', component: HomeComponent },
    { path: 'guest', component: GuestComponent },
    { path: 'reports', component: ReportsComponent, canActivate: [AuthGuard] },
    { path: 'login', component: LoginComponent },
    { path: 'admin', component: AdminComponent, canActivate: [AuthGuard] },
    { path: 'review', component: ReportsComponent, canActivate: [AuthGuard] },
    { path: 'repcomp', component: ReportsComponent }
];

/*export const ROUTING: ModuleWithProviders = RouterModule.forRoot(ROUTES) */
export const ROUTING: ModuleWithProviders = RouterModule.forRoot(ROUTES, { useHash: false })



// WEBPACK FOOTER //
// ./src/app/app.routing.ts